(function(){
  var root = document.querySelector('[data-nyx-ship-pill]');
  if(!root) return;

  var dot = root.querySelector('.nyx-ship-pill__dot');
  var lead = root.querySelector('[data-nyx-ship-lead]');
  var out = root.querySelector('[data-nyx-ship-date]');

  function addDays(d, days){
    var x = new Date(d.getTime());
    x.setDate(x.getDate() + days);
    return x;
  }

  function nextMonday(d){
    var day = d.getDay();
    var delta = (8 - day) % 7;
    if(delta === 0) delta = 7;
    return addDays(d, delta);
  }

  function calcShipDate(now){
    var day = now.getDay();
    var hour = now.getHours();
    var beforeCutoff = hour < 16;
    if(day === 0 || day === 6) return nextMonday(now);
    if(day === 5) return beforeCutoff ? now : nextMonday(now);
    return beforeCutoff ? now : addDays(now, 1);
  }

  function formatDayMonth(d){
    var months = ["January","February","March","April","May","June",
                  "July","August","September","October","November","December"];
    return months[d.getMonth()] + " " + d.getDate();
  }

  var txt = root.querySelector('.nyx-ship-pill__txt');

  function renderInStock(){
    root.classList.remove('is-outofstock');
    dot.classList.remove('is-outofstock');
    dot.classList.add('is-instock');
    txt.innerHTML =
      '<span class="nyx-ship-pill__lead" data-nyx-ship-lead>In stock — order today, ships on</span>' +
      '<strong class="nyx-ship-pill__date" data-nyx-ship-date>' +
      formatDayMonth(calcShipDate(new Date())) +
      '</strong>';
  }

  function renderOutOfStock(){
    root.classList.add('is-outofstock');
    dot.classList.remove('is-instock');
    dot.classList.add('is-outofstock');
    txt.innerHTML = '<span class="nyx-ship-pill__lead" data-nyx-ship-lead>Out of stock</span>';
  }

  if (out) {
    renderInStock();
  }

  document.addEventListener('variant:changed', function(e){
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    if (variant.available) {
      renderInStock();
    } else {
      renderOutOfStock();
    }
  });
})();